import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from 'src/axios';
import { QUERY_KEY_SKU_FORECAST_DATA } from 'src/keys';
import forecastService from 'src/services/forecast/forecastService';
import type { ForecastDataPoint } from 'src/types/domain/ForecastDataPoint';

export type SkuForecastData = ForecastDataPoint[];

export const useSkuForecastDataQuery = <T = SkuForecastData>(
  sku: string,
): UseQueryResult<T, Error> => {
  return useQuery({
    queryKey: [QUERY_KEY_SKU_FORECAST_DATA, sku],
    queryFn: async () => {
      const { data } = await api.get(`/sales-forecasting/${sku}`);
      return forecastService.formatForecastData(data, sku) as T;
    },
  });
};
